export default __webpack_public_path__ + "static/media/14.449cc66f.png";